<unity-dropdown-clickable-control
  linkRoot="/role"
  displayName="Role"
  description="Select a role."
  [readonly]="true"
  [control]="$control()"
  [selectable]="$validRoles()" />
